var UnsavedDataSheetEnum = /* @__PURE__ */ ((UnsavedDataSheetEnum2) => {
  UnsavedDataSheetEnum2["UNSAVED_DATA_SHEET"] = "unsaved-data-sheet";
  UnsavedDataSheetEnum2["UNSAVED_DATA_SHEET_SAVE_BUTTON"] = "unsaved-data-sheet--save-button";
  UnsavedDataSheetEnum2["UNSAVED_DATA_SHEET_DISCARD_BUTTON"] = "unsaved-data-sheet--discard-button";
  UnsavedDataSheetEnum2["UNSAVED_DATA_SHEET_TITLE"] = "unsaved-data-sheet-title";
  return UnsavedDataSheetEnum2;
})(UnsavedDataSheetEnum || {});
export {
  UnsavedDataSheetEnum
};
